import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=bb7f9146&scoped=true"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=bb7f9146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f9146",
  null
  
)

export default component.exports